import { IonItem, IonText } from "@ionic/react";

import { EditableInput } from "~components/Atoms";
import { translate } from "~utils";

import { EditableFieldsBase } from "./types";

type EditableTextProps = EditableFieldsBase & {
  isInset?: boolean;
};

export const EditableText: React.FC<EditableTextProps> = ({
  isEditing,
  placeholder,
  value,
  label,
  onChange,
  className,
  lines,
  isInset,
}) => {
  return (
    <IonItem className={className} lines={isEditing ? undefined : lines}>
      {isEditing ? (
        <EditableInput value={value} placeholder={placeholder} label={label} onChange={onChange} />
      ) : (
        <div className="flex w-full gap-4 pb-4">
          <div className={isInset ? "px-4" : ""}>
            <p className={`font-medium ${isInset && "mt-2 mb-1"}`}>{label}</p>
            <IonText>
              {value || <span className="italic">{translate("NOT_PROVIDED")}</span>}
            </IonText>
          </div>
        </div>
      )}
    </IonItem>
  );
};
